import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

export interface IPrivateRouteProps extends RouteProps {
  component: any; // TODO: find the correct type
  isAuthenticated: boolean;
}

const privateRoute = ({
  component: Component,
  isAuthenticated,
  ...rest
}: IPrivateRouteProps) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/login" }} />
      )
    }
  />
);

export default privateRoute;
